import { getUtmParams } from '../bi';
import { isBuilder } from '../helpers';

export const resolveTrackingLink = (params) => {
    const { affiliateId, afp, afp1, afp2, afp3, brand, utmCampaign, landingPage, widgetType } = params;

    const utmParams = getUtmParams({
        affiliateId,
        brand,
        afp,
        afp1,
        afp2,
        afp3,
        landingPage,
        utmCampaign,
        widgetType,
        utmTerm: 'gig_ads_widget',
    });

    const trackingLink = `https://gigads.fiverr.com/visit?${utmParams}`;

    // if Widget used inside Builder set direct link to Fiverr without BI data
    // otherwise set href to gigads.fiverr.com
    return isBuilder ? landingPage : trackingLink;
};
